import { useEffect, useState } from "react";
import { toast } from "sonner";
import { vendorSponsorOptions, vendorSponsorCheckout } from "../lib/api";

// Vendor self-serve: buy a labelled sponsored slot (priced per month, 3-month
// minimum, 12 months = 10 paid) on a page the tool already belongs to.
export default function SponsorPanel({ slug }) {
  const [data, setData] = useState(null);
  const [pick, setPick] = useState("");
  const [months, setMonths] = useState(3);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    vendorSponsorOptions(slug).then(setData).catch(() => setData({ options: [], active: [], terms: [], min_months: 3, annual_months_charged: 10 }));
  }, [slug]);
  if (!data) return null;
  const opt = (data.options || []).find((o) => o.placement === pick);
  const buy = async () => {
    setBusy(true);
    try {
      const r = await vendorSponsorCheckout(slug, pick, months);
      window.location.href = r.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "could not start checkout");
      setBusy(false);
    }
  };
  return (
    <div className="mt-4" data-testid={`sponsor-panel-${slug}`}>
      <h3 className="text-[14px] font-bold border-b border-[#ddd] pb-1">sponsored slot</h3>
      <p className="text-[12px] text-[#666] mt-1">
        A labelled &quot;sponsored&quot; row above the ranked list on a page your tool already belongs to. Max 3 per page (2 on the homepage).
        Priced per month, {data.min_months}-month minimum, billed up front; 12 months costs {data.annual_months_charged} (two free). Your rank in the list itself never changes.
      </p>
      {(data.active || []).length > 0 && (
        <ul className="mt-2 text-[12px]" data-testid={`sponsor-active-${slug}`}>
          {(data.active || []).map((s) => (
            <li key={s.id}>★ {s.placement_label} — until {String(s.ends_at).slice(0, 10)}</li>
          ))}
        </ul>
      )}
      <div className="mt-2 flex flex-wrap items-center gap-2 text-[12px]">
        <select value={pick} onChange={(e) => setPick(e.target.value)} className="border border-black p-1 font-mono text-[12px] max-w-full" data-testid={`sponsor-select-${slug}`}>
          <option value="">choose a page…</option>
          {(data.options || []).map((o) => (
            <option key={o.placement} value={o.placement} disabled={o.slots_left <= 0}>
              {`${o.label} — $${o.month_usd}/mo ${o.slots_left <= 0 ? "(full)" : `(${o.slots_left} left)`}`}
            </option>
          ))}
        </select>
        <select value={months} onChange={(e) => setMonths(Number(e.target.value))} className="border border-black p-1 font-mono text-[12px]" data-testid={`sponsor-months-${slug}`}>
          {(data.terms || []).map((m) => (
            <option key={m} value={m}>{`${m} months${m >= 12 ? " (2 free)" : ""}${opt ? ` — $${Number(opt.totals[String(m)]).toFixed(0)}` : ""}`}</option>
          ))}
        </select>
        <button type="button" className="tv-btn tv-btn-primary" disabled={!opt || busy} onClick={buy} data-testid={`sponsor-buy-${slug}`}>
          {busy ? "…" : opt ? `[buy — $${Number(opt.totals[String(months)]).toFixed(0)} for ${months} months]` : "[buy]"}
        </button>
      </div>
    </div>
  );
}
